import { IParsedTable } from '../parse-csv';
import { IImportPlan, IPreviewRow } from './i-asset-type-import';

const cellAt = (cells: string[], columnIndex: number): string => (
  columnIndex >= 0 ? cells[columnIndex] ?? '' : ''
);

export const buildPreviewRows = (table: IParsedTable, plan: IImportPlan): IPreviewRow[] => (
  table.rows.map((cells, index) => ({
    key: `r${index}`,
    line: table.rowLines[index] ?? index + 1,
    code: cellAt(cells, plan.codeColumn),
    description: cellAt(cells, plan.descriptionColumn),
    props: plan.propertyColumns.map((column) => cellAt(cells, column.columnIndex)),
    status: 'new' as const,
    errors: {},
    warnings: {},
  }))
);
